import * as React from "react";
import { SVGProps } from "react";

interface IChatBubbleTypingOvalIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}
export function ChatBubbleTypingOvalIcon({
    color = "#000",
    ...props
  }: IChatBubbleTypingOvalIconProps) {
  return (
    <svg
      width={21}
      height={21}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.502 10.928a.357.357 0 1 1 0-.714"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10.928a.357.357 0 0 0 0-.714M6.572 10.928a.357.357 0 1 1 0-.714"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.57 10.928a.357.357 0 1 0 0-.714M14.431 10.928a.357.357 0 1 1 0-.714"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.43 10.928a.357.357 0 0 0 0-.714"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.496 1.372A9.2 9.2 0 0 0 2.84 15.666L1.297 19.77l5.166-.933a9.2 9.2 0 1 0 4.033-17.465Z"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
